var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoImageNextActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55399 0.492287C7.89258 -0.0156091 8.5788 -0.152853 9.0867 0.185745L13.5077 3.13309C14.0156 3.47169 14.1529 4.1579 13.8143 4.6658L10.8669 9.08681C10.5283 9.59471 9.8421 9.73195 9.3342 9.39336C8.82631 9.05476 8.68906 8.36854 9.02766 7.86065L10.7346 5.3003C8.73773 5.56679 6.8707 6.20406 5.40252 7.18285C3.44675 8.4867 2.21051 10.3761 2.21051 12.8947C2.21051 13.5052 1.71567 14 1.10525 14C0.494839 14 0 13.5052 0 12.8947C0 9.51867 1.71111 6.98709 4.17635 5.3436C5.76515 4.2844 7.6705 3.58662 9.66803 3.23L7.86053 2.025C7.35263 1.6864 7.21539 1.00018 7.55399 0.492287Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImageNextActive);
export default __webpack_public_path__ + "static/media/ico_image_next_active.48ec79f13ebdbf5f83e3e7c21ac98925.svg";
export { ForwardRef as ReactComponent };